<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card v-if="showDialog">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="display-1 primary--text">Evaluación docente</h3>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="!encuestaRealizada">
                        <h3 class="section-head headline primary--text mb-3">¡IMPORTANTE!</h3>
                        <p>La evaluación docente del periodo <strong>{{nombrePeriodo}}</strong>. Es una actividad OBLIGATORIA para inscribirte en el próximo periodo.</p>
                        <p>Puedes contestar la evaluación UNICAMENTE del <strong>{{fechaInicio}}</strong> al <strong>{{fechaFin}}</strong>.</p>
                        <p><strong>NOTA:</strong> LA MATERIA DE RESIDENCIAS PROFESIONALES HA SIDO OMITIDA, YA QUE NO SE REQUIERE EVALUAR AL ASESOR EN ESTE PERIODO.</p>
                        <p>Te recordamos que el profesor recibe sus resultados a través de una gráfica que se entrega al final del semestre una vez que ha reportado calificaciones.</p>
                        <p>¡CONTESTA CON HONESTIDAD!</p>
                        <h3 class="red--text">¡ATENCION!</h3>
                        <ul class="red--text text--darken-4">
                            <li><strong>UNA VEZ INICIADA LA ENCUESTA DEBE TERMINARSE EN SU TOTALIDAD.</strong></li>
                            <li><strong>SI SE PRESENTAN INCONVENIENTES AL MOMENTO DE REALIZARLA, COMUNICARSE AL DEPARTAMENTO DE DESARROLLO ACADEMICO.</strong></li>
                        </ul>
                    </v-card-text>
                    <v-card-text v-else>
                        <p>{{mensajeError}}</p>
                    </v-card-text>
                    <v-card-actions v-if="!encuestaRealizada">
                        <v-btn color="info" @click.native="showEncuesta = true">Comenzar encuesta</v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <v-card-text>
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showEncuesta" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary" fixed>
                    <v-btn icon dark @click.native="showEncuesta = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Evaluación Docente</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat @click.native="guardar" v-if="puedeFinalizar" :loading="guardando">Terminar</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pa-0">
                    <v-stepper v-model="pregunta" vertical v-if="preguntas" class="mt-5">
                        <template v-for="item in preguntas">
                            <v-stepper-step
                                    :complete="pregunta > item.consecutivo"
                                    :key="`${item.consecutivo}-step`"
                                    :step="item.consecutivo">
                                {{item.pregunta}}
                                <small>{{item.respuestas}}</small>
                            </v-stepper-step>
                            <v-stepper-content
                                    :key="`${item.consecutivo}-content`"
                                    :step="item.consecutivo"
                            >
                                <v-alert
                                        :value="hasError"
                                        color="error"
                                        icon="warning"
                                        outline
                                >
                                    {{errorMessage}}
                                </v-alert>
                                <template v-for="materia in materias">
                                    <MyRatings :index="item.consecutivo" :materia="materia" v-bind:respuestas.sync="respuestas"></MyRatings>
                                </template>
                                <v-btn color="primary" @click="nextStep(item.consecutivo)">Siguiente</v-btn>
                            </v-stepper-content>
                        </template>
                    </v-stepper>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import * as moment from 'moment'
  import MyRatings from '@/components/MyRatings'

  export default {
    name: 'EvaluacionDocentePage',
    components: {MyRatings},
    mounted () {
      this.validarPeriodoEvaluacionDocente()

      if (this.preguntas !== null) {
        this.respuestas.fill({}, 1, this.preguntas.length)
      }
    },
    data: () => ({
      showDialog: false,
      showEncuesta: false,
      encuestaRealizada: false,
      nombrePeriodo: '',
      fechaInicio: '',
      fechaFin: '',
      preguntas: null,
      materias: [],
      pregunta: 0,
      totalItems: 0,
      respuestas: [],
      hasError: false,
      errorMessage: '',
      guardando: false
    }),
    computed: {
      puedeFinalizar () {
        if (this.preguntas === null) {
          return false
        }
        return (this.respuestas.length === (this.preguntas.length + 1)) && this.validaRespuestas(this.preguntas.length)
      }
    },
    methods: {
      validarPeriodoEvaluacionDocente () {
        axios.get('alumno/evaluacion-docente/valida-evaluacion')
          .then(resp => {
            if (resp.data.code === 200) {
              this.nombrePeriodo = resp.data.nombrePeriodo

              moment.locale('es')

              this.fechaInicio = moment(resp.data.fecha_inicio).format('D [de] MMMM [de] YYYY')
              this.fechaFin = moment(resp.data.fecha_fin).format('D [de] MMMM [de] YYYY')
              this.obtenerPreguntas()
              this.obtenerMaterias()
            } else if (resp.data.code === 400) {
              this.encuestaRealizada = true
              this.mensajeError = resp.data.message
            }
            this.showDialog = true
          })
      },
      obtenerPreguntas () {
        if (this.preguntas !== null) {
          return
        }

        axios.get('alumno/evaluacion-docente/preguntas')
          .then(resp => {
            this.preguntas = resp.data
            this.pregunta = 1
          })
      },
      obtenerMaterias () {
        if (this.materias.length > 0) {
          return
        }

        axios.get('alumno/evaluacion-docente/materias')
          .then(resp => {
            this.materias = resp.data
          })
      },
      nextStep (n) {
        if (!this.validaRespuestas(n)) {
          console.log('No se han capturado todas las respuestas del paso número: ' + n)
          this.hasError = true
          this.errorMessage = 'No se han capturado todas las respuestas, por favor termina.'
          return
        } else {
          this.hasError = false
        }

        if (n === (this.preguntas.length + 1)) {
          this.pregunta = 1
        } else {
          this.pregunta = n + 1
        }
      },
      validaRespuestas (numeroPregunta) {
        if (this.pregunta > numeroPregunta && this.pregunta < numeroPregunta) {
          return true
        } else if (this.pregunta === numeroPregunta) {
          let respuesta = this.respuestas[numeroPregunta]
          if (respuesta === undefined) {
            return false
          } else if (Object.keys(respuesta).length >= this.materias.length) {
            return true
          }
        } else if ((this.preguntas.length + 1) >= this.pregunta) {
          return true
        }

        return false
      },
      guardar () {
        let jsonData = {}

        for (let materia in this.materias) {
          const m = this.materias[materia].materia
          jsonData[m] = {
            respuestas: '',
            rfc: this.materias[materia].rfc
          }
        }

        for (let r in this.respuestas) {
          if (this.respuestas[r] === null) {
            continue
          }

          for (let materia in this.respuestas[r]) {
            jsonData[materia].respuestas += this.respuestas[r][materia].toString()
          }
        }

        this.guardando = true

        axios.post('alumno/evaluacion-docente/guardar', jsonData)
          .then(resp => {
            this.showEncuesta = false
            this.encuestaRealizada = true
            this.mensajeError = 'Gracias por realizar la encuesta.'
            this.guardando = false
          })
          .catch(err => {
            console.log(err)
            this.guardando = false
          })
      }
    }
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/evaluacion-docente/EvaluacionDocentePage.vue